"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentTableType = exports.StakeSuggesterAlgorithm = exports.StakeMode = exports.SportTag = exports.SportEventType = exports.SportEventStatus = exports.SportEventState = exports.SportEventOrder = exports.SortDirection = exports.RestrictionType = exports.OddStatus = exports.OddAcceptStrategy = exports.MarketType = exports.MarketStatus = exports.FreebetConditionType = exports.FreebetBetDetailsType = exports.FreebetBetDetailsConditionType = exports.FeaturedSportType = exports.CompetitorType = exports.CompetitorHomeAway = exports.CashOutOrderStatusCode = exports.BetType = exports.BetStatus = exports.BetSortFields = exports.BetSettlementStatus = exports.BannerType = void 0;
var BannerType;
(function (BannerType) {
    BannerType["cms_banner"] = "cms_banner";
    BannerType["betting_sport_event"] = "betting_sport_event";
    BannerType["betting_tournament"] = "betting_tournament";
    BannerType["betting_live_of_the_day"] = "betting_live_of_the_day";
    BannerType["betting_match_of_the_day"] = "betting_match_of_the_day";
})(BannerType = exports.BannerType || (exports.BannerType = {}));
var BetSettlementStatus;
(function (BetSettlementStatus) {
    BetSettlementStatus["PROCESSING"] = "PROCESSING";
    BetSettlementStatus["ACCEPTED"] = "ACCEPTED";
    BetSettlementStatus["DECLINED"] = "DECLINED";
    BetSettlementStatus["WON"] = "WON";
    BetSettlementStatus["LOST"] = "LOST";
    BetSettlementStatus["REFUNDED"] = "REFUNDED";
    BetSettlementStatus["REDEEMED"] = "REDEEMED";
})(BetSettlementStatus = exports.BetSettlementStatus || (exports.BetSettlementStatus = {}));
var BetSortFields;
(function (BetSortFields) {
    BetSortFields["CREATED_AT"] = "CREATED_AT";
    BetSortFields["STATUS_UPDATED_AT"] = "STATUS_UPDATED_AT";
})(BetSortFields = exports.BetSortFields || (exports.BetSortFields = {}));
var BetStatus;
(function (BetStatus) {
    BetStatus["INIT"] = "INIT";
    BetStatus["CREATED"] = "CREATED";
    BetStatus["PLACED"] = "PLACED";
    BetStatus["PLACE_ERROR"] = "PLACE_ERROR";
    BetStatus["ARBITRAGE_ACCEPTED"] = "ARBITRAGE_ACCEPTED";
    BetStatus["ARBITRAGE_DECLINED"] = "ARBITRAGE_DECLINED";
    BetStatus["ACCEPTED"] = "ACCEPTED";
    BetStatus["DECLINED"] = "DECLINED";
    BetStatus["SETTLED"] = "SETTLED";
    BetStatus["UNSETTLED"] = "UNSETTLED";
    BetStatus["ROLLED_BACK"] = "ROLLED_BACK";
    BetStatus["FORCED_DECLINED"] = "FORCED_DECLINED";
})(BetStatus = exports.BetStatus || (exports.BetStatus = {}));
var BetType;
(function (BetType) {
    BetType["SINGLE"] = "SINGLE";
    BetType["EXPRESS"] = "EXPRESS";
    BetType["SYSTEM"] = "SYSTEM";
})(BetType = exports.BetType || (exports.BetType = {}));
var CashOutOrderStatusCode;
(function (CashOutOrderStatusCode) {
    CashOutOrderStatusCode["pending"] = "pending";
    CashOutOrderStatusCode["accepted"] = "accepted";
    CashOutOrderStatusCode["declined"] = "declined";
})(CashOutOrderStatusCode = exports.CashOutOrderStatusCode || (exports.CashOutOrderStatusCode = {}));
var CompetitorHomeAway;
(function (CompetitorHomeAway) {
    CompetitorHomeAway["UNKNOWN"] = "UNKNOWN";
    CompetitorHomeAway["HOME"] = "HOME";
    CompetitorHomeAway["AWAY"] = "AWAY";
})(CompetitorHomeAway = exports.CompetitorHomeAway || (exports.CompetitorHomeAway = {}));
var CompetitorType;
(function (CompetitorType) {
    CompetitorType["OTHER"] = "OTHER";
    CompetitorType["PERSON"] = "PERSON";
    CompetitorType["TEAM"] = "TEAM";
})(CompetitorType = exports.CompetitorType || (exports.CompetitorType = {}));
var FeaturedSportType;
(function (FeaturedSportType) {
    FeaturedSportType["CLASSIC"] = "CLASSIC";
    FeaturedSportType["ESPORT"] = "ESPORT";
})(FeaturedSportType = exports.FeaturedSportType || (exports.FeaturedSportType = {}));
var FreebetBetDetailsConditionType;
(function (FreebetBetDetailsConditionType) {
    FreebetBetDetailsConditionType["ODDS_COEFFICIENT"] = "ODDS_COEFFICIENT";
    FreebetBetDetailsConditionType["ODDS_COUNT"] = "ODDS_COUNT";
    FreebetBetDetailsConditionType["TOTAL_ODDS_COEFFICIENT"] = "TOTAL_ODDS_COEFFICIENT";
    FreebetBetDetailsConditionType["COMBINATIONS_COUNT"] = "COMBINATIONS_COUNT";
    FreebetBetDetailsConditionType["SYSTEM_SIZE"] = "SYSTEM_SIZE";
    FreebetBetDetailsConditionType["COMPETITOR"] = "COMPETITOR";
    FreebetBetDetailsConditionType["MARKET_TYPE"] = "MARKET_TYPE";
    FreebetBetDetailsConditionType["SPORT_EVENT"] = "SPORT_EVENT";
    FreebetBetDetailsConditionType["SPORT"] = "SPORT";
    FreebetBetDetailsConditionType["TOURNAMENT"] = "TOURNAMENT";
})(FreebetBetDetailsConditionType = exports.FreebetBetDetailsConditionType || (exports.FreebetBetDetailsConditionType = {}));
var FreebetBetDetailsType;
(function (FreebetBetDetailsType) {
    FreebetBetDetailsType["SINGLE"] = "SINGLE";
    FreebetBetDetailsType["SYSTEM"] = "SYSTEM";
    FreebetBetDetailsType["EXPRESS"] = "EXPRESS";
})(FreebetBetDetailsType = exports.FreebetBetDetailsType || (exports.FreebetBetDetailsType = {}));
var FreebetConditionType;
(function (FreebetConditionType) {
    FreebetConditionType["bet_type"] = "bet_type";
    FreebetConditionType["event_match_ids"] = "event_match_ids";
    FreebetConditionType["tournaments"] = "tournaments";
    FreebetConditionType["competitors"] = "competitors";
    FreebetConditionType["odd_ratio"] = "odd_ratio";
    FreebetConditionType["kind_of_sport_id"] = "kind_of_sport_id";
    FreebetConditionType["market_types"] = "market_types";
    FreebetConditionType["country"] = "country";
    FreebetConditionType["bet_details"] = "bet_details";
})(FreebetConditionType = exports.FreebetConditionType || (exports.FreebetConditionType = {}));
var MarketStatus;
(function (MarketStatus) {
    MarketStatus["ACTIVE"] = "ACTIVE";
    MarketStatus["SUSPENDED"] = "SUSPENDED";
    MarketStatus["DEACTIVATED"] = "DEACTIVATED";
    MarketStatus["RESULTED"] = "RESULTED";
    MarketStatus["CANCELLED"] = "CANCELLED";
})(MarketStatus = exports.MarketStatus || (exports.MarketStatus = {}));
var MarketType;
(function (MarketType) {
    MarketType["MATCH"] = "MATCH";
    MarketType["OUTRIGHT"] = "OUTRIGHT";
})(MarketType = exports.MarketType || (exports.MarketType = {}));
var OddAcceptStrategy;
(function (OddAcceptStrategy) {
    /** default strategy, only small odd value changes allowed if odd changes during acceptance process */
    OddAcceptStrategy["DEVIATION_ALLOWED"] = "DEVIATION_ALLOWED";
    /** greater odd values allowed if odd changes during acceptance process */
    OddAcceptStrategy["GREATER_ALLOWED"] = "GREATER_ALLOWED";
    /** all odd values allowed if odd changes during acceptance process */
    OddAcceptStrategy["ALWAYS_ALLOWED"] = "ALWAYS_ALLOWED";
})(OddAcceptStrategy = exports.OddAcceptStrategy || (exports.OddAcceptStrategy = {}));
var OddStatus;
(function (OddStatus) {
    OddStatus["NOT_RESULTED"] = "NOT_RESULTED";
    OddStatus["WIN"] = "WIN";
    OddStatus["LOSS"] = "LOSS";
    OddStatus["HALF_WIN"] = "HALF_WIN";
    OddStatus["HALF_LOSS"] = "HALF_LOSS";
    OddStatus["REFUNDED"] = "REFUNDED";
    OddStatus["CANCELLED"] = "CANCELLED";
})(OddStatus = exports.OddStatus || (exports.OddStatus = {}));
var RestrictionType;
(function (RestrictionType) {
    RestrictionType["max_bet"] = "max_bet";
    RestrictionType["max_odd_bet"] = "max_odd_bet";
    RestrictionType["bet_type"] = "bet_type";
    RestrictionType["bet_interval"] = "bet_interval";
    RestrictionType["bet_delay"] = "bet_delay";
    RestrictionType["bet_tournament_duplicate_competitor_ids"] = "bet_tournament_duplicate_competitor_ids";
    RestrictionType["bet_tournament_incompatible_market_ids"] = "bet_tournament_incompatible_market_ids";
    RestrictionType["selection_value"] = "selection_value";
    RestrictionType["sport_event_status"] = "sport_event_status";
    RestrictionType["sport_event_type"] = "sport_event_type";
    RestrictionType["sport_event_existence"] = "sport_event_existence";
    RestrictionType["sport_event_bet_stop"] = "sport_event_bet_stop";
    RestrictionType["market_status"] = "market_status";
    RestrictionType["market_existence"] = "market_existence";
    RestrictionType["market_defective"] = "market_defective";
    RestrictionType["odd_status"] = "odd_status";
    RestrictionType["odd_existence"] = "odd_existence";
    RestrictionType["bet_cash_out_selections_mismatch"] = "bet_cash_out_selections_mismatch";
    RestrictionType["cash_out_amount_limit"] = "cash_out_amount_limit";
    RestrictionType["cash_out_refund_amount"] = "cash_out_refund_amount";
    RestrictionType["cash_out_order_status"] = "cash_out_order_status";
    RestrictionType["baseline_selection_existence"] = "baseline_selection_existence";
    RestrictionType["bet_status"] = "bet_status";
    RestrictionType["bet_provider"] = "bet_provider";
    RestrictionType["bet_selection_existence"] = "bet_selection_existence";
    RestrictionType["cash_out_unavailable"] = "cash_out_unavailable";
    RestrictionType["cash_out_bet_type"] = "cash_out_bet_type";
    RestrictionType["cash_out_order_freebet"] = "cash_out_order_freebet";
    RestrictionType["player_limit"] = "player_limit";
    RestrictionType["not_enough_balance"] = "not_enough_balance";
})(RestrictionType = exports.RestrictionType || (exports.RestrictionType = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var SportEventOrder;
(function (SportEventOrder) {
    /** Doesn't apply any sorting */
    SportEventOrder["NONE"] = "NONE";
    SportEventOrder["RANK"] = "RANK";
    /** One of the types, that specified as default in ranking service */
    SportEventOrder["RANK_DEFAULT"] = "RANK_DEFAULT";
    /** Sort by live flag and start time of sport events */
    SportEventOrder["RANK_START_TIME"] = "RANK_START_TIME";
    /** Sort by sport events statistics */
    SportEventOrder["RANK_PROFIT"] = "RANK_PROFIT";
    /** Sort by 'top' flag */
    SportEventOrder["RANK_TOP"] = "RANK_TOP";
    /** Ranker that specified on backend for 'live' page */
    SportEventOrder["RANK_LIVE_PAGE"] = "RANK_LIVE_PAGE";
    /** Ranker that uses ds model to rank sport events by player bet history */
    SportEventOrder["RANK_PERSONALIZED"] = "RANK_PERSONALIZED";
    /** Ranker that uses ds model to rank sport events by player country */
    SportEventOrder["RANK_REGIONAL"] = "RANK_REGIONAL";
})(SportEventOrder = exports.SportEventOrder || (exports.SportEventOrder = {}));
var SportEventState;
(function (SportEventState) {
    SportEventState["LIVE"] = "LIVE";
    SportEventState["PREMATCH"] = "PREMATCH";
    SportEventState["UNKNOWN"] = "UNKNOWN";
})(SportEventState = exports.SportEventState || (exports.SportEventState = {}));
var SportEventStatus;
(function (SportEventStatus) {
    SportEventStatus["NOT_STARTED"] = "NOT_STARTED";
    SportEventStatus["LIVE"] = "LIVE";
    SportEventStatus["SUSPENDED"] = "SUSPENDED";
    SportEventStatus["ENDED"] = "ENDED";
    SportEventStatus["CLOSED"] = "CLOSED";
    SportEventStatus["CANCELLED"] = "CANCELLED";
    SportEventStatus["ABANDONED"] = "ABANDONED";
    SportEventStatus["DELAYED"] = "DELAYED";
    SportEventStatus["UNKNOWN"] = "UNKNOWN";
})(SportEventStatus = exports.SportEventStatus || (exports.SportEventStatus = {}));
var SportEventType;
(function (SportEventType) {
    SportEventType["MATCH"] = "MATCH";
    SportEventType["OUTRIGHT"] = "OUTRIGHT";
})(SportEventType = exports.SportEventType || (exports.SportEventType = {}));
var SportTag;
(function (SportTag) {
    SportTag["CLASSIC"] = "CLASSIC";
    SportTag["ESPORT"] = "ESPORT";
})(SportTag = exports.SportTag || (exports.SportTag = {}));
var StakeMode;
(function (StakeMode) {
    StakeMode["total"] = "total";
    StakeMode["chunk"] = "chunk";
})(StakeMode = exports.StakeMode || (exports.StakeMode = {}));
var StakeSuggesterAlgorithm;
(function (StakeSuggesterAlgorithm) {
    StakeSuggesterAlgorithm["BY_MAX_BET"] = "BY_MAX_BET";
    StakeSuggesterAlgorithm["BY_CURRENCY"] = "BY_CURRENCY";
    StakeSuggesterAlgorithm["BY_CURRENCY_2"] = "BY_CURRENCY_2";
    StakeSuggesterAlgorithm["BY_WL"] = "BY_WL";
})(StakeSuggesterAlgorithm = exports.StakeSuggesterAlgorithm || (exports.StakeSuggesterAlgorithm = {}));
var TournamentTableType;
(function (TournamentTableType) {
    TournamentTableType["KNOCKOUT_SINGLE"] = "KNOCKOUT_SINGLE";
})(TournamentTableType = exports.TournamentTableType || (exports.TournamentTableType = {}));
//# sourceMappingURL=gql.js.map